<template>
  <v-layout
    row
    wrap
  >
    <v-flex>
      <v-card class="max-shadow">
        <v-card-title class="pa-1">
          <v-toolbar
            flat
            color="white"
            height="48"
          >
            <v-spacer />
            <v-toolbar-items>
              <search-widget
                v-model="search"
              />
              <v-btn
                to="/max-admin/tenants/add"
                color="primary"
                flat
              >
                Add Tenant
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>
        <v-data-table
          :headers="tenantsHeaders"
          :items="tenants"
          :search="search"
          :loading="tenantsDataLoading"
          :no-results-text="'Your search for ' + search + ' found no results.'"
          class="px-2 pb-2"
          item-key="id"
          no-data-text="No tenant is added"
          hide-actions
          disable-initial-sort
        >
          <template
            slot="items"
            slot-scope="props"
          >
            <tr @click="$router.push('/max-admin/tenants/' + props.item.id)">
              <td>{{ props.index + 1 }}</td>
              <td class="text-xs-left">
                {{ props.item.companyName }}
              </td>
              <td class="text-xs-left">
                {{ props.item.admin.name }}
              </td>
              <td class="text-xs-left">
                {{ formatTime(props.item.moveInDate) }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import * as moment from 'moment';

import { firestore } from '@/firebase';
import SearchWidget from '@/components/common/SearchWidget';

export default {
  name: 'TenantsTable',
  components: {
    'search-widget': SearchWidget
  },
  data() {
    return {
      tenants: [],
      tenantsHeaders: [
        {
          text: '#',
          value: false,
          align: 'left'
        },
        {
          text: 'Company Name',
          value: 'companyName',
          align: 'left'
        },
        {
          text: 'Admin Name',
          value: 'admin.name',
          align: 'left'
        },
        {
          text: 'Move-in Date',
          value: 'moveInDate',
          align: 'left'
        }
      ],
      search: '',
      tenantsDataLoading: true,
      firebaseListeners: []
    };
  },
  created() {
    this.tenantsListener();
  },
  beforeDestroy() {
    // unsubscribe all firebase listeners
    this.firebaseListeners.forEach(listenerFunc => {
      listenerFunc();
    });
  },
  methods: {
    tenantsListener() {
      const tenantsListener = firestore
        .collection('tenants')
        .onSnapshot(tenantsSnapshot => {
          this.tenantsDataLoading = false;
          this.tenants = [];
          tenantsSnapshot.forEach(tenantSnapshot => {
            const tenant = tenantSnapshot.data();
            tenant.id = tenantSnapshot.id;
            // convert firebase timestamp to date object
            tenant.moveInDate = tenantSnapshot.get('moveInTime').toDate();
            this.tenants.push(tenant);
          });
        });
      this.firebaseListeners.push(tenantsListener);
    },

    formatTime(time) {
      return moment(time).format('DD MMM YYYY hh:mm A');
    }
  }
};
</script>

<style scoped></style>
